import { useEffect } from "react"
import { attributionName } from "shared-ts/classes/user"
import { UUID } from "shared-ts/classes/uuid"

import { useAppSelector } from "app/hooks"
import {
  useGetCompanyQuery,
  useGetCurrentUserQuery,
} from "features/api/company"
import { selectLocation } from "features/auth/authSlice"

export function useIntercom() {
  const { data: companyRes } = useGetCompanyQuery({})
  const { data: userRes } = useGetCurrentUserQuery({})
  const location = useAppSelector(selectLocation)

  useEffect(() => {
    if (typeof window.Intercom !== "function") {
      return
    }

    if (!companyRes?.company || !userRes?.user) {
      return
    }

    const { company } = companyRes
    if (!company.id) {
      return
    }

    const { user } = userRes
    if (!user.staffId) {
      return
    }

    window.Intercom("update", {
      name: attributionName(user),
      user_id: UUID.fromPB(user.staffId).toString(),
      phone: location?.phone,
      email: user.email,
      cell_phone: user.phone,
      company: {
        id: UUID.fromPB(company.id).toString(),
        name: company.name,
        subdomain: company.subdomain,
        website: `https://${company.subdomain}.rundoo.app`,
      },
      roles: user.roleIds.join(", "),
      num_permissions: user.roleIds.length ?? 0,
    })
  }, [companyRes, userRes, location])
}

// Helper to open Intercom with context
export function openIntercom({ fromAIChat = false } = {}) {
  if (typeof window.Intercom !== "function") {
    return
  }

  window.Intercom("update", { from_llm_chat: fromAIChat })
  window.Intercom("show")
}
